<template>
  <v-layout>
    <v-flex xs12>
      <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
      <apexchart
        ref="tagreport"
        type="bar"
        height="600"
        width="100%"
        :options="options"
        :series="series"
      ></apexchart>
    </v-flex>
  </v-layout>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from './../DashboardGraphLoading'

export default {
  components: {
    apexchart: VueApexCharts,
    DashboardGraphLoading
  },
  props: ['selectedDate', 'data', 'loading'],
  data() {
    return {}
  },
  computed: {
    options() {
      return {
        chart: {
          id: 'vuechart-example'
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: this.data.map((v) => v.intent)
        }
      }
    },
    series() {
      return [
        {
          name: 'Total',
          data: this.data.map((v) => v.count)
        }
      ]
    },
    usertags() {
      return this.data.map((v) => v.intent)
    },
    count() {
      return this.data.map((v) => v.count)
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/inbox/InboxStatGraph.vue